import { createAction } from '@reduxjs/toolkit';

import { ListDiscounts200Response } from '@ce-openapi/moka-inventory-discount-service-ts-axios-client';
import {
  Discount,
  postCreateDiscountWithOutlets,
} from '../../../api/libraries/discounts';
import {
  LIBRARY_DISCOUNT_SET_OUTLETS,
  LIBRARY_DISCOUNT_OUTLETS_REQUEST,
  LIBRARY_DISCOUNT_ON_CHANGE_OUTLET_IDS,
  LIBRARY_DISCOUNT_ON_CLICK_CREATE_DISCOUNT,
  LIBRARY_DISCOUNT_ON_CLICK_ROW,
  LIBRARY_DISCOUNT_SET_DISCOUNT_DETAIL,
  LIBRARY_DISCOUNT_SET_CURRENT_PAGE,
  LIBRARY_DISCOUNT_SET_TOTAL_PAGE,
  LIBRARY_DISCOUNT_UNSET_DISCOUNT,
  LIBRARY_DISCOUNT_SET_CREATE_DISCOUNT,
  LIBRARY_DISCOUNT_CLEAR_AMOUNT_FIELD,
  LIBRARY_DISCOUNT_SUBMIT_FORM_CREATE,
  LIBRARY_DISCOUNT_SUBMIT_FORM_CREATE_ALL_OUTLET,
  LIBRARY_DISCOUNT_SUBMIT_FORM_UPDATE,
  LIBRARY_DISCOUNT_ASK_DELETE_DISCOUNT,
  LIBRARY_DISCOUNT_DELETE_DISCOUNT,
  LIBRARY_DISCOUNT_CANCEL_DELETE_DISCOUNT,
  LIBRARY_DISCOUNT_SHOW_DELETE_DISCOUNT_MODAL,
  LIBRARY_DISCOUNT_HIDE_DELETE_DISCOUNT_MODAL,
  LIBRARY_DISCOUNT_SET_DELETED_DISCOUNT,
  LIBRARY_DISCOUNT_ON_CLICK_CANCEL,
  LIBRARY_DISCOUNT_IS_SUBMITTING_FORM,
  LIBRARY_DISCOUNT_ON_CLICK_ASSIGN_OUTLET,
  LIBRARY_DISCOUNT_ON_CLICK_CANCEL_ASSIGN_OUTLET_MODAL,
  LIBRARY_DISCOUNT_SHOW_ASSIGN_OUTLET_MODAL,
  LIBRARY_DISCOUNT_HIDE_ASSIGN_OUTLET_MODAL,
  LIBRARY_DISCOUNT_SET_SELECTED_OUTLETS,
  LIBRARY_DISCOUNT_SET_PARTIAL_OUTLETS,
  LIBRARY_DISCOUNT_SEARCH_OUTLET,
  LIBRARY_DISCOUNT_SELECT_ALL_OUTLETS,
  LIBRARY_DISCOUNT_UNSELECT_ALL_OUTLETS,
  LIBRARY_DISCOUNT_ON_CLICK_ASSIGN_DISCOUNT_ASSIGN_OUTLET_MODAL,
  LIBRARY_DISCOUNT_OUTLET_SUBMIT_FORM_UPDATE,
  LIBRARY_DISCOUNT_OUTLET_DELETE_DISCOUNT,
  LIBRARY_DISCOUNT_OUTLET_SHOW_ERROR_OUTLET_NOT_ASSIGNED,
  LIBRARY_DISCOUNT_OUTLET_HIDE_ERROR_OUTLET_NOT_ASSIGNED,
  LIBRARY_DISCOUNT_OUTLET_SHOW_BUTTON_VIEW_MORE_OUTLETS,
  LIBRARY_DISCOUNT_OUTLET_HIDE_BUTTON_VIEW_MORE_OUTLETS,
  LIBRARY_DISCOUNT_OUTLET_ON_CLICK_VIEW_MORE_OUTLETS,
  LIBRARY_DISCOUNT_OUTLET_SHOW_ERROR_DUPLICATE_DISCOUNT_NAME,
  LIBRARY_DISCOUNT_OUTLET_HIDE_ERROR_DUPLICATE_DISCOUNT_NAME,
} from './constants';

export const pageRequest = createAction('libraryDiscount/discountPageRequest');

export function setOutlets(outlets) {
  return { type: LIBRARY_DISCOUNT_SET_OUTLETS, payload: { outlets } };
}

export function outletsRequest(params) {
  return { type: LIBRARY_DISCOUNT_OUTLETS_REQUEST, payload: { params } };
}

export const discountsRequest = createAction<{
  previousDiscounts: any;
  params: { page: number; outletIds?: string[] };
}>('libraryDiscount/discountsRequest');

export const customDiscountsRequest = createAction<{
  previousDiscounts: ListDiscounts200Response['results'];
  params: {
    cursor: ListDiscounts200Response['next_cursor'];
    outletIds?: string[];
  };
}>('libraryDiscount/customDiscountsRequest');

export function onChangeOutletIds(outletIds) {
  return {
    type: LIBRARY_DISCOUNT_ON_CHANGE_OUTLET_IDS,
    payload: { outletIds },
  };
}

export function onClickCreateDiscount(outlets) {
  return {
    type: LIBRARY_DISCOUNT_ON_CLICK_CREATE_DISCOUNT,
    payload: { outlets },
  };
}

export function setNewDiscount() {
  return { type: LIBRARY_DISCOUNT_SET_CREATE_DISCOUNT };
}

export function onClickRow(discount, outlets) {
  return {
    type: LIBRARY_DISCOUNT_ON_CLICK_ROW,
    payload: { discount, outlets },
  };
}

export const setDiscounts = createAction<Discount[]>(
  'libraryDiscount/setDiscounts'
);

export const setCustomDiscounts = createAction<
  ListDiscounts200Response['results']
>('libraryDiscount/setCustomDiscounts');

export const setCustomDiscountsCursor = createAction<{
  cursor: ListDiscounts200Response['next_cursor'];
  completed: boolean;
}>('libraryDiscount/setCustomDiscountsCursor');

export function setDiscountDetail(discount) {
  return { type: LIBRARY_DISCOUNT_SET_DISCOUNT_DETAIL, payload: { discount } };
}

export function unSetDiscountDetail() {
  return { type: LIBRARY_DISCOUNT_UNSET_DISCOUNT, payload: {} };
}

export function clearAmountField() {
  return { type: LIBRARY_DISCOUNT_CLEAR_AMOUNT_FIELD, payload: {} };
}

export function setCurrentPage(currentPage) {
  return { type: LIBRARY_DISCOUNT_SET_CURRENT_PAGE, payload: { currentPage } };
}

export function setTotalPage(totalPage) {
  return { type: LIBRARY_DISCOUNT_SET_TOTAL_PAGE, payload: { totalPage } };
}

export function submitFormCreate(data, previousDiscounts) {
  return {
    type: LIBRARY_DISCOUNT_SUBMIT_FORM_CREATE,
    payload: { data, previousDiscounts },
  };
}

export function submitFormCreateAllOutlet(data, previousDiscounts) {
  return {
    type: LIBRARY_DISCOUNT_SUBMIT_FORM_CREATE_ALL_OUTLET,
    payload: { data, previousDiscounts },
  };
}

export function submitFormUpdate(discountId, data, previousDiscounts) {
  return {
    type: LIBRARY_DISCOUNT_SUBMIT_FORM_UPDATE,
    payload: { discountId, data, previousDiscounts },
  };
}

export function deleteDiscount(discountId, previousDiscounts) {
  return {
    type: LIBRARY_DISCOUNT_DELETE_DISCOUNT,
    payload: { discountId, previousDiscounts },
  };
}

export function cancelDeleteDiscount() {
  return { type: LIBRARY_DISCOUNT_CANCEL_DELETE_DISCOUNT, payload: {} };
}

export function showDeleteDiscountModal() {
  return { type: LIBRARY_DISCOUNT_SHOW_DELETE_DISCOUNT_MODAL, payload: {} };
}

export function hideDeleteDiscountModal() {
  return { type: LIBRARY_DISCOUNT_HIDE_DELETE_DISCOUNT_MODAL, payload: {} };
}

export function setDeletedDiscount(deletedDiscount) {
  return {
    type: LIBRARY_DISCOUNT_SET_DELETED_DISCOUNT,
    payload: { deletedDiscount },
  };
}

export function askDeleteDiscount(deletedDiscount) {
  return {
    type: LIBRARY_DISCOUNT_ASK_DELETE_DISCOUNT,
    payload: { deletedDiscount },
  };
}

export function onClickCancel() {
  return { type: LIBRARY_DISCOUNT_ON_CLICK_CANCEL, payload: {} };
}

export function isSubmittingForm(isSubmittingFormPayload) {
  return {
    type: LIBRARY_DISCOUNT_IS_SUBMITTING_FORM,
    payload: { isSubmittingForm: isSubmittingFormPayload },
  };
}

export function onClickAssignOutletButton() {
  return {
    type: LIBRARY_DISCOUNT_ON_CLICK_ASSIGN_OUTLET,
  };
}

export function showDiscountAssignOutletModal() {
  return {
    type: LIBRARY_DISCOUNT_SHOW_ASSIGN_OUTLET_MODAL,
  };
}

export function hideDiscountAssignOutletModal() {
  return {
    type: LIBRARY_DISCOUNT_HIDE_ASSIGN_OUTLET_MODAL,
  };
}

export function onClickCancelModal(previousSelectedOutlets) {
  return {
    type: LIBRARY_DISCOUNT_ON_CLICK_CANCEL_ASSIGN_OUTLET_MODAL,
    payload: { previousSelectedOutlets },
  };
}

export function setSelectedOutlets(selectedOutlets) {
  return {
    type: LIBRARY_DISCOUNT_SET_SELECTED_OUTLETS,
    payload: { selectedOutlets },
  };
}

export function setPartialOutlets(partialOutlets) {
  return {
    type: LIBRARY_DISCOUNT_SET_PARTIAL_OUTLETS,
    payload: { partialOutlets },
  };
}

export function searchOutlet(outlets, searchKeyword) {
  return {
    type: LIBRARY_DISCOUNT_SEARCH_OUTLET,
    payload: { outlets, searchKeyword },
  };
}

export function selectAllOutlets(allOutletsForm) {
  return {
    type: LIBRARY_DISCOUNT_SELECT_ALL_OUTLETS,
    payload: { allOutletsForm },
  };
}

export function unselectAllOutlets(allOutletsForm) {
  return {
    type: LIBRARY_DISCOUNT_UNSELECT_ALL_OUTLETS,
    payload: { allOutletsForm },
  };
}

export function onClickAssignPromoModal(assignedOutlets) {
  return {
    type: LIBRARY_DISCOUNT_ON_CLICK_ASSIGN_DISCOUNT_ASSIGN_OUTLET_MODAL,
    payload: { assignedOutlets },
  };
}

export const submitDiscountOutletFormCreate = createAction<{
  data: Parameters<typeof postCreateDiscountWithOutlets>[0];
  email: string;
  phone: string;
  selectedOutletIds: string[];
}>('libraryDiscount/submitCreateOutletForm');

export function submitDiscountOutletFormUpdate(
  data,
  previousDiscountDetail,
  email,
  phone,
  selectedOutletIds
) {
  return {
    type: LIBRARY_DISCOUNT_OUTLET_SUBMIT_FORM_UPDATE,
    payload: { data, previousDiscountDetail, email, phone, selectedOutletIds },
  };
}

export function deleteDiscountOutlet(data, selectedOutletIds) {
  return {
    type: LIBRARY_DISCOUNT_OUTLET_DELETE_DISCOUNT,
    payload: { data, selectedOutletIds },
  };
}

export function showErrorOutletNotAssigned() {
  return {
    type: LIBRARY_DISCOUNT_OUTLET_SHOW_ERROR_OUTLET_NOT_ASSIGNED,
  };
}

export function hideErrorOutletNotAssigned() {
  return {
    type: LIBRARY_DISCOUNT_OUTLET_HIDE_ERROR_OUTLET_NOT_ASSIGNED,
  };
}

export function showViewMoreOutletsButton() {
  return {
    type: LIBRARY_DISCOUNT_OUTLET_SHOW_BUTTON_VIEW_MORE_OUTLETS,
  };
}

export function hideViewMoreOutletsButton() {
  return {
    type: LIBRARY_DISCOUNT_OUTLET_HIDE_BUTTON_VIEW_MORE_OUTLETS,
  };
}

export function onClickViewMoreButton(currentIndex, detailDiscount, outlets) {
  return {
    type: LIBRARY_DISCOUNT_OUTLET_ON_CLICK_VIEW_MORE_OUTLETS,
    payload: { currentIndex, detailDiscount, outlets },
  };
}

export function showErrorDuplicateDiscountName() {
  return {
    type: LIBRARY_DISCOUNT_OUTLET_SHOW_ERROR_DUPLICATE_DISCOUNT_NAME,
  };
}

export function hideErrorDuplicateDiscountName() {
  return {
    type: LIBRARY_DISCOUNT_OUTLET_HIDE_ERROR_DUPLICATE_DISCOUNT_NAME,
  };
}
